import { MapSearchAutoComplete } from './map_search_autocomplete';

class MapSearch {
  constructor(locations, viewType) {
    this.locations = locations;
    this.viewType = viewType;
    this.filters = document.querySelectorAll('.custom-switch.friendly-type input[type=checkbox]');
    this.problemFilter = document.querySelector('.custom-switch.problems input[type=checkbox]');
    this.parkWithFilters = document.querySelectorAll('[aria-labelledby="dropdownParkWithFilter"] .dropdown-item');
    this.buildListeners();
    this.setMinHeight();
  }

  activateAutoComplete(locationSelectedCallback, placeSelectedCallback, googleService, placeService, sessionToken) {
    return new MapSearchAutoComplete(this, locationSelectedCallback, placeSelectedCallback, googleService, placeService, sessionToken, this.viewType);
  }

  synchronizeWith(searchEngine) {
    this.searchEngine = searchEngine;
    this.runFilter();
  }

  buildListeners() {
    this.filters.forEach(filter => {
      filter.addEventListener('change', () => this.runFilter());
    });
    if (this.problemFilter) {
      this.problemFilter.addEventListener('change', () => this.runFilter());
    }
    this.parkWithFilters.forEach(filter => {
      filter.addEventListener('click', (event) => {
        MapSearch.updateParkWithFilter(event.target, this.parkWithFilters);
        this.runFilter();
      });
    });
  }

  prepareFilters() {
    const f = [];
    const dropdown = document.getElementById('dropdownParkWithFilter');
    if (!dropdown) {
      return f;
    }
    const parkWithFilter = this.parkWithFilterFactory(dropdown.dataset.parkWithFilter);
    const searchText = document.getElementById('search')?.value || '';

    if (this.problemFilter?.checked) {
      f.push(location => location.type === 'friendly_type');
      const problemReportsCheckbox = document.querySelector('.custom-switch.problems input[type=checkbox][data-filter-type="Problem reports"]');
      const problems = problemReportsCheckbox?.checked;
      if (problems) {
        f.push(location => (location.type === 'problems') && !((location.problem_reports?.length > 0) || (location.work_orders?.length > 0)));
      }
    } else {
      f.push(location => location.type === 'problems');
    }

    this.filters.forEach(filter => {
      if (!filter.checked) {
        f.push(location => location.location_friendly_type === filter.dataset.filterType);
      }
    });
    f.push(location => !parkWithFilter(location));

    return f;
  }

  searchLocations(searchedText) {
    return function(location) {
      if (searchedText === '') {
        return true;
      }
      return MapSearch.searching(location, searchedText);
    };
  }

  static searching(location, searchedText) {
    const street_address = location.street_address || '';
    const city = location.city || '';
    const lowerSearchText = searchedText.toLowerCase();
    return (location.human_name.toLowerCase().includes(lowerSearchText)) ||
      (street_address.toLowerCase().includes(lowerSearchText)) ||
      (city.toLowerCase().includes(lowerSearchText));
  }

  static updateParkWithFilter(activeFilter, parkWithFilters) {
    const dropdown = document.getElementById('dropdownParkWithFilter');
    dropdown.innerHTML = activeFilter.innerHTML;
    dropdown.dataset.parkWithFilter = activeFilter.dataset.parkWithFilter;
    parkWithFilters.forEach(filter => {
      if (activeFilter.dataset.parkWithFilter === filter.dataset.parkWithFilter) {
        filter.style.cssText = 'display:none !important';
      } else {
        filter.style.cssText = 'display:block !important';
      }
    });
  }

  parkWithFilterFactory(activeFilter) {
    if (activeFilter === 'any-access-device') {
      return location => (location.location_friendly_type === 'Vendor') || (location.supported_card_model_ids?.length > 0);
    } else if (activeFilter === 'clipper-card') {
      return location => location.can_use_clipper_card;
    } else if (activeFilter === 'bikelink-card') {
      return location => location.can_use_bikelink_card;
    } else if (activeFilter === 'bikelink-app') {
      return location => location.can_use_mobile_app;
    } else if (activeFilter === 'tap-card') {
      return location => location.can_use_tap_card;
    }
  }

  runFilter() {
    this.searchEngine.call(this.prepareFilters());
  }

  runChecking(filters, location) {
    let show = true;
    filters.forEach(filter => {
      if (filter(location) && show) {
        show = false;
      }
    });
    return show;
  }

  static refreshFilters(oldFilters) {
    const currentFilters = document.querySelectorAll('.custom-switch input[type=checkbox]');
    currentFilters.forEach(filter => {
      oldFilters.forEach(oldFilter => {
        if (filter.dataset.filterType === oldFilter.dataset.filterType) {
          filter.checked = oldFilter.checked;
        }
      });
    });
  }

  static refreshSearchState(oldSearchFilter, oldFilter, oldParkWithFilter) {
    MapSearch.refreshFilters(oldFilter);
    const parkWithItems = document.querySelectorAll('[aria-labelledby="dropdownParkWithFilter"] .dropdown-item');
    MapSearch.updateParkWithFilter(oldParkWithFilter, parkWithItems);
    const searchInput = document.getElementById('search');
    if (searchInput && oldSearchFilter) {
      searchInput.value = oldSearchFilter.value;
    }
  }

  setMinHeight() {
    const filterGroups = document.querySelectorAll('main .filter-group');
    if (filterGroups.length >= 4) {
      document.querySelector('main').style.minHeight = '52.5rem';
    }
  }
}

export { MapSearch };
